/**
 * Helpers for typing, parsing and formatting
 * option objects for selects.
 */

export interface OptionProp<ValueType> {
  value: ValueType;
  label: string;
  type?: string;
}

export interface GroupedOptionProp<ValueType> {
  label: string;
  options: OptionProp<ValueType>[];
}

export const optionPropParse = <T>(opt?: OptionProp<T> | null) =>
  opt?.value || null;

export const optionPropFormat =
  <T>(optionList: OptionProp<T>[]) =>
  (value: T): OptionProp<T> => ({
    value: value || ('' as T),
    label: optionList.find((opt) => opt.value === value)?.label || '',
  });
